export const REVIEW_DEFAULT_FPS = 24
export const REVIEW_TIMELINE_WINDOW_SEC = 60
export const REVIEW_TIMELINE_MIN_WINDOW_SEC = 15

export function formatReviewTimecode(sec: number, fps = REVIEW_DEFAULT_FPS): string {
  if (!Number.isFinite(sec) || sec < 0) sec = 0
  const totalFrames = Math.round(sec * fps)
  const ff = totalFrames % fps
  const totalSec = Math.floor(totalFrames / fps)
  const s = totalSec % 60
  const m = Math.floor(totalSec / 60) % 60
  const h = Math.floor(totalSec / 3600)
  const pad2 = (n: number) => n.toString().padStart(2, '0')
  if (h > 0) return `${h}:${pad2(m)}:${pad2(s)}:${pad2(ff)}`
  return `${m}:${pad2(s)}:${pad2(ff)}`
}

export function formatReviewTimecodeRange(
  startMs: number,
  endMs: number,
  fps = REVIEW_DEFAULT_FPS,
): string {
  const a = formatReviewTimecode(startMs / 1000, fps)
  if (startMs === endMs) return a
  return `${a} – ${formatReviewTimecode(endMs / 1000, fps)}`
}

export function secToMs(sec: number): number {
  return Math.max(0, Math.round(sec * 1000))
}

export function frameIndexAt(sec: number, fps = REVIEW_DEFAULT_FPS): number {
  return Math.round(sec * fps)
}
